import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/runs/$runId')({
  component: lazyRouteComponent(() => import('@/pages/run-detail/page'), 'RunDetailPage'),
  validateSearch: (search: Record<string, unknown>) => {
    const tab = search.tab
    const validTabs = ['reports', 'excursions', 'run-info', 'execution-trace']
    const activeTab = typeof tab === 'string' && validTabs.includes(tab) ? tab : 'reports'
    const excursionId = typeof search.excursionId === 'string' ? search.excursionId : undefined
    return { tab: activeTab, excursionId }
  },
})
